module.exports = __webpack_public_path__ + "img/Multigain.fc593330.jpeg";